/**
 * Die Phasenleiste im Kopf des Seitenpanels: Triage › Prüfung › Bid/No-Bid › Konzept › Angebot abgeben › Ergebnis.
 *
 * Abgeleitet aus der gespeicherten Phase und davon, ob der Prozess noch läuft — es gibt keine eigene
 * Phase „Konzept“ (entschieden 20.10.2026, tri-server docs/tender-concept-step.md): In
 * `angebotserstellung` ist „Konzept“ dran, solange der Prozess läuft, danach „Angebot abgeben“.
 * No-Bid springt direkt zu „Ergebnis: kein Angebot“; die übersprungenen Schritte heißen so.
 */

export type PhaseBarKey = "triage" | "pruefung" | "bid" | "konzept" | "angebot" | "ergebnis";
export type PhaseBarState = "done" | "current" | "todo" | "skipped";

export const PHASE_BAR_KEYS: PhaseBarKey[] = ["triage", "pruefung", "bid", "konzept", "angebot", "ergebnis"];

export function phaseBarSteps(input: {
  phase: string | null;
  outcome: string | null;
  processLive: boolean;
}): Array<{ key: PhaseBarKey; state: PhaseBarState }> {
  const at = (index: number, skipped: PhaseBarKey[] = []) =>
    PHASE_BAR_KEYS.map((key, i) => ({
      key,
      state: (skipped.includes(key) ? "skipped" : i < index ? "done" : i === index ? "current" : "todo") as PhaseBarState,
    }));
  switch (input.phase) {
    case "pruefung":
      return at(1);
    case "bid-entscheidung":
      return at(2);
    case "angebotserstellung":
      return at(input.processLive ? 3 : 4);
    case "abgegeben":
      return at(5);
    case "ergebnis":
      // Ein Ergebnis ist das Ende — „kein Angebot“ überspringt Konzept und Abgabe.
      return at(6, input.outcome === "kein-angebot" ? ["konzept", "angebot"] : []).map((step) =>
        step.key === "ergebnis" ? { ...step, state: "current" } : step,
      );
    default:
      return at(0);
  }
}
